import unfetch from 'unfetch'
import { AbstractStatefulLoader } from '../../types/lux/stateful'
import StatefulLoadable from './StatefulLoadable'

export default AbstractStatefulLoader

/** @type {typeof fetch} */
let Fetch
if (typeof fetch === 'function') {
  Fetch = fetch
} else {
  Fetch = /** @type {typeof fetch} */ (unfetch)
}

/** @constructor @extends {AbstractStatefulLoader} @suppress {checkTypes} */ function _StatefulLoader() {}
AbstractStatefulLoader.__implement(StatefulLoadable,
  _StatefulLoader.prototype = /** @type {!AbstractStatefulLoader} */ ({
    processJSON(d) {
      const { 'data': data, 'error': error } = d
      if (error) throw new Error(error)
      return data
    },
    async fetchJSON(path,opts,throwErrors) {
      const{
        asIStatefulLoadable:{wrapLoader},
        asIStatefulLoader:{processJSON},
      } = this
      return await wrapLoader(async () => {
        try {
          const res = await Fetch(path, opts)
          if (res.status != 200) {
            throw new Error(`Response status ${res.status}`)
          }
          const contentType = res.headers.get('content-type')
          if (contentType && /application\/json/.test(contentType)) {
            const data = await res.json()
            if (!data) throw new Error(NO_RESPONSE)
            return processJSON(/** @type {!Object} */ (data))
          } else {
            const text = await res.text()
            const data = JSON.parse(text)
            if (!data) throw new Error(NO_RESPONSE)
            return processJSON(/** @type {!Object} */ (data))
          }
        } catch (error) {
          if (error instanceof Event) {
            // eslint-disable-next-line no-ex-assign
            error = new Error('Network Error')
          }
          throw error
        }
      }, throwErrors)
    },
  }),
)

const NO_RESPONSE = 'No response from the server.'